import { RAISE_API_V1_URL } from "constants/endpoints";
import { get, post, deleteMethod, put } from "services/api";

const BRAND_ALERT_URL = `${RAISE_API_V1_URL}/brand_alerts`;

export const getUserBrandAlerts = async () => {
  const response = await get(BRAND_ALERT_URL);

  return response.data.data;
};

export const saveBrandAlert = async ({
  productSourceId,
  maximumValue,
  minimumValue,
  minimumDiscount,
  frequency
}) => {
  const response = await post(BRAND_ALERT_URL, {
    brand_alert: {
      product_source_id: productSourceId,
      minimum_value: minimumValue,
      maximum_value: maximumValue,
      minimum_discount: minimumDiscount,
      frequency
    }
  });
  return response.data;
};

export const updateBrandAlert = async ({
  productSourceId,
  maximumValue,
  minimumValue,
  minimumDiscount,
  frequency
}) => {
  const response = await put(`${BRAND_ALERT_URL}/${productSourceId}`, {
    brand_alert: {
      product_source_id: productSourceId,
      minimum_value: minimumValue,
      maximum_value: maximumValue,
      minimum_discount: minimumDiscount,
      frequency
    }
  });
  return response.data;
};

export const deleteBrandAlertByProductId = async ({ productSourceId }) => {
  const response = await deleteMethod(`${BRAND_ALERT_URL}/${productSourceId}`);
  return response.data;
};
